export const scrollToBottom = (className: string): void => {
  let scrollElement: HTMLElement | null = null;

  if (className === "overflowYScroll") {
    scrollElement = document.querySelector(
      "[data-overlayscrollbars-viewport~=overflowYScroll]"
    ) as HTMLElement;
  } else {
    scrollElement = document.querySelector(`.${className}`) as HTMLElement;
  }
  if (scrollElement) {
    setTimeout(() => {
      scrollElement!.scrollTo({
        top: scrollElement!.scrollHeight,
        behavior: "smooth"
      });
    }, 0);
  }
};
